// extracted by mini-css-extract-plugin
export default {"root":"IXeSpaKMItliCqRoZuOw","space":"ZAwsN5ogShsLWSTarW0F","total":"ptRU3fBSYH8hdu6R_9MX","placeHolderShimmer":"kRUXDnAW65qb0briTvbI"};